import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTrailerPoolReport } from "./autogen/AutogenLayoutTrailerPoolReport";

export class TrailerPoolReport extends AutogenLayoutTrailerPoolReport {
    override onLoad(): void | Promise<void> {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[3];
    }

    excludabletextboxFTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }

    excludabletextboxLocationTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent){
        event.filter.is_trailer_pool = "Y"
    }
}
